class TimelineSteps extends HTMLElement {
  constructor() {
    super();
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.timeline-step'));
    this.points = Array.from(this.querySelectorAll('.timeline-step__point'));
    this.fills = Array.from(this.querySelectorAll('.timeline-step__connector-fill'));

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    requestAnimationFrame(() => {
      requestAnimationFrame(() => this.onScroll());
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    requestAnimationFrame(() => this.onScroll());
  }

  onScroll() {
    if (!this.points.length) return;

    const viewportCenter = window.innerHeight / 2;

    this.items.forEach((item, i) => {
      const pointRect = this.points[i].getBoundingClientRect();
      const pointCenter = pointRect.top + pointRect.height / 2;

      // Circle activates when viewport center passes it
      if (pointCenter <= viewportCenter) {
        item.classList.add('is--active');
      } else {
        item.classList.remove('is--active');
      }

      // Fill the connector below this circle toward the next circle
      const fill = this.fills[i];
      if (!fill || i >= this.points.length - 1) return;

      const nextRect = this.points[i + 1].getBoundingClientRect();
      const nextCenter = nextRect.top + nextRect.height / 2;
      const distance = nextCenter - pointCenter;
      const traveled = viewportCenter - pointCenter;

      if (traveled <= 0) {
        fill.style.height = '0%';
      } else if (traveled >= distance) {
        fill.style.height = '100%';
      } else {
        fill.style.height = ((traveled / distance) * 100) + '%';
      }
    });
  }
}

customElements.define('timeline-steps', TimelineSteps);
